import { render, staticRenderFns } from "./render.vue?vue&type=template&id=f704a458&scoped=true"
import script from "./render.vue?vue&type=script&lang=ts"
export * from "./render.vue?vue&type=script&lang=ts"
import style1 from "./render.vue?vue&type=style&index=1&id=f704a458&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f704a458",
  null
  
)

export default component.exports